import { useForm } from "react-hook-form";
import styled from "styled-components";
import SanitizeInputFunction from "../../../../Functions/SanitizeInputFunction";
import { useContext, useState } from "react";
import GreenCheck from "./img/green-check.png"
import RedCheck from "./img/red-check.png"
import NameIcon from "./img/account_circle.png"
import PasswordIcon from "./img/key.png"
import SanitizePasswordFunction from "../../../../Functions/SanitizePasswordFunction";
import { PageContext } from "../../../../Context/PageContext";
import PopUpWarning, { PopUpCaller } from "../../../../PopUpWarning/PopUpWarning";
import EmailConfirmFormulary, { GenerateValidationCodeFunction } from "../../../../EmailConfirmFormulary/EmailConfirmFormulary";
import { ApiConnectLionsUserChangePassword, ApiConnectLogRegister, ApiConnectTicketCreation } from "../../../../api/LionsUserApiConect";
import SolicitarVip from "../SolicitarVip";
import OperationSucess from "./OperationSucess";
import PopUpImg from "../img/wallpaper_60_1024.png"
import UserNotLogged from "../UserNotLogged";

function CreateNewTicket() {

    const {register, getValues} = useForm();
    const { user, setPopMenuContent, setPage, setIsLogged} = useContext(PageContext)
    const [submitButtonColor, setSubmitButtonColor] = useState("rgba(112, 118, 113, 0.5)");
    const [availableSubmit, setAvailableSubmit] = useState("none");
    

    function fieldsValidation(){


        if(getValues('ticketTitle') === "" || getValues('ticketTitle').length < 5 || getValues('topic') === "" || getValues('description') === "") {
            setSubmitButtonColor("rgba(112, 118, 113, 0.5)");
            setAvailableSubmit("none");
            return;
        }
        else { 
            setSubmitButtonColor("rgb(11, 85, 158)");
            setAvailableSubmit("auto");}
        return;
        }

        async function submitAndCreateTicket() {

            var negado = "Criação de Ticket Negada! Você já tem um ticket aberto no momento."

            let newPassUser = user;
            newPassUser.userPassword = getValues('userPassword');

            const agora = new Date();
            const hora = agora.getHours();
            const Minuto = agora.getMinutes();
            const Segundo = agora.getSeconds();
            const ano = agora.getFullYear();
            const mes = (agora.getMonth() + 1).toString().padStart(2, '0');
            const dia = agora.getDate().toString().padStart(2, '0');
            const dataApiFormat = `${ano}${mes}${dia}${hora}${Minuto}${Segundo}`;

            let ticketDto = {
                ticketId : 0,
                requestNumber : dataApiFormat,
                userName : user.userName,
                userEmail : user.userEmail,
                topic : getValues('topic'),
                title : getValues('ticketTitle'),
                description : getValues('description'),
                creationDate : null,
                ticketstatus : 'Aberto',
                ongoingStatusDate : null,
                closedDate : null
                }

            let result = ApiConnectTicketCreation(ticketDto);
                result.then((response) => {

                    if(response.status == 403 || response.status == 401) {
                        setPage(<UserNotLogged />);
                        setIsLogged(false);
                        return;
                    }
                    if(response.data != true) {
                        PopUpCaller(negado,"rgba(191, 18, 18, 0.8)", 10000);
                        return;
                    } else if(response.data === true){ 
                        ApiConnectLogRegister(user, `Criou um novo Ticket ${dataApiFormat} em: `);
                        setPopMenuContent(<OperationSucess />);
                    }
            })
        }



    return(
        <MasterContainer>
        <CreateTicketMasterContainer >
            <h1>NOVO TICKET</h1>
            <HeaderDescription>
                <span>Preencha os campos abaixo para criar um novo ticket de suporte.<br/></span>
                <span>Responderemos o mais breve possível.<br/></span><br/>
                <span><b>Atenção:</b> Ao criar um novo ticket você declara a veracidade das informações fornecidas. <br/></span>
            </HeaderDescription>

            <PopUpWarning />

                    <AcessoItemContainer>
                        <ColumItemHeaderName>Tópico</ColumItemHeaderName>
                        <Select  {...register("topic", {
                                onChange: () => {fieldsValidation()}
                            })}>
                            <Option value="">(Escolha uma opção)</Option>
                            <option value="Geral">Geral</option>
                            <option value="Bugs">Bugs</option>
                            <option value="Servidor">Servidor</option>
                            <option value="Doações">Doações</option>
                            <option value="Acesso VIP">Acesso VIP</option>
                            <option value="Denúncias">Denúncias</option>
                        </Select>
                    </AcessoItemContainer>


                    <AcessoItemContainer>
                            <ColumItemHeaderName>Titulo</ColumItemHeaderName>
                        <Input
                            type="text"
                            maxlength="50"
                            {...register("ticketTitle", {
                                onChange: () => {fieldsValidation()}
                            })}
                            placeholder="Titulo do ticket"
                            required />
                    </AcessoItemContainer>

                    <DescriptionContainer>
                        <h2>Descrição</h2> 
                        <span>Descreva no campo abaixo o assunto que deseja tratar:</span><br/>
                        <DescriptionInput
                        type="fieldtext"
                        maxlength="200"
                        placeholder="(Descreva o assunto aqui..)"
                        {...register('description', {
                            onChange: () =>{fieldsValidation()}
                            })
                        }
                        required
                        />
                    </DescriptionContainer>


                    <ConfirmInput
                    color={submitButtonColor}
                    onClick={() => {
                        GenerateValidationCodeFunction(user.userName, user.userEmail, "codeToEmail");
                        setPopMenuContent(
                        <EmailConfirmFormulary
                            ActionFunction={submitAndCreateTicket}
                            userMail={user.userEmail}>
                        </EmailConfirmFormulary>
                        )
                    }
                    }
                    value="Criar Ticket"
                    available={availableSubmit}
                    />
        </CreateTicketMasterContainer>

        <BgPopUp bgp={PopUpImg}/>
        </MasterContainer>
    )
}

export default CreateNewTicket;

const MasterContainer = styled.div`
    display: flex;
    border: solid 1px;
    align-items: center;
    background-color: white;
    border-radius: 10px;
    box-shadow: 10px 10px 10px 0 black;
    height: 100%;
`


const CreateTicketMasterContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    background-color: rgb(255, 255, 255);
    border-radius: 10px;
    width: 600px;
    margin: 5px 0;
    transition: .3s ease-in-out;
    //color: white;

 

    &:hover {
    transform: translate(0px, 0px);
    //background-color: rgba(65, 102, 137, 0.8);
    //color: white;

    }

`

const AcessoItemContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    //border: solid 2px black;
    width: 420px;
    font-size: 18px;
    text-align: center;
    //border: solid;
    margin-bottom: 20px;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

`


const Input = styled.input`
    height: 30px;
    width: 200px;
    border-radius: 0px;
    border: solid 0px rgba(0,0,0,.5);
    border-bottom: solid 1px rgba(0,0,0,.3);
    font-size: 16px;
    text-align: center;

`


const ColumItemHeaderIcon = styled.div`
    background-image: url(${props => props.iconImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 25px;
    height: 25px;
    margin-right: 20px;
`

const ColumItemHeaderName = styled.span`
    font-weight: bold;
    width: 50px;
    margin-right: 20px;
    font-size: 14pt;
`

const ConfirmInput = styled.input`
    height: 50px;
    padding: 0px 5px;
    width: 200px;
    margin: 30px 0;
    border-radius: 5px;
    font-size: 14pt;
    border: none;
    background-color: ${props => props.color};
    color: white;
    transition: .3s ease-in-out;
    text-align: center;
    pointer-events: ${props => props.available};

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    &:hover {
    scale: 1.1;
    
    }
`

const Select = styled.select`
    display: flex;
    align-items: center;
    text-align: center;
    width: 300px;
    height: 30px;
    justify-content: center;
    font-size: 14pt;
    transition: .3s ease-in-out;
    cursor: pointer;
`
const Option = styled.option`
    
`

const HeaderDescription = styled.div`
    text-align: justify;
    padding: 20px;
    width: 500px;

`

const DescriptionContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    //border: solid;
    width: 500px;

`

const DescriptionInput = styled.textarea`
    display: flex;
    justify-content: center;
    height: 100px;
    width: 440px;
    border-radius: 10px;
    border: solid 1px rgba(0,0,0,.5);
    //border-bottom: solid 1px rgba(0,0,0,.3);
    font-size: 14pt;
    padding: 10px;
    overflow: auto;
    resize: none;

`

const BgPopUp = styled.div`
    background-image: url(${props => props.bgp});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 525px;
    height: 730px;
    //border: solid;

    @media(max-width: 1000px) {
      background-image: url('');
      width: 0px;
    }

`